import React from 'react';

const PlainCard = ({
  title,
  content,
  updated,
  randomNum,
  className,
  onClick,
  onDelete,
  onEdit,
  isLogged,
}) => {
  return (
    <div className="" onClick={onClick}>
      <div className={`card ${randomNum > 1 ? 'text-center' : ''} ${className}`}>
        {isLogged && (
          <div className="card-buttons">
            <span className="fa fa-pen card-btn" onClick={onEdit} />
            <span className="fa fa-trash card-btn" onClick={onDelete} />
          </div>
        )}
        <div className="card-body">
          <h5 className="card-title">{title}</h5>
          <p className="card-text">{content}</p>
          <p className="card-text">
            <small className="text-muted">{updated}</small>
          </p>
        </div>
      </div>
    </div>
  );
};

export default PlainCard;
